module.exports = __webpack_public_path__ + "static/media/logo.5ecbfc54.svg";